import React from 'react';
import { Box, Text, SimpleGrid, Card, HStack, Button, VStack, NativeSelect, Progress } from '@chakra-ui/react';
import StatCard from '../../../components/utils/StatCard';
import AppAvatar from '../../../components/utils/AppAvatar';
import { FaLayerGroup, FaMapMarkedAlt, FaCampground, FaBookOpen } from "react-icons/fa";
import { MdEdit } from "react-icons/md";

const ControlTile = ({ title, status, statusColor, options = [], ctaLabel }) => (
  <VStack align="stretch" gap="3" w="full">
    <HStack>
      <Button aria-label={status} bg={statusColor} />
      <Box>
        <Text fontWeight="semibold">{title}</Text>
        <Text fontSize="sm" fontWeight="light">{status}</Text>
      </Box>
    </HStack>

    <Box>
      <Text fontWeight="semibold" mb="1">{title}</Text>
      <NativeSelect.Root w="full">
        <NativeSelect.Field w="full">
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </Box>

    <Button w="full">{ctaLabel}</Button>
  </VStack>
);

const Nivel = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Campus Monterrey</Text>
      <Text pb="5">Administra los niveles del Campus Monterrey</Text>
      <SimpleGrid pb="5" columns={[2, 4]} gap="2">
        <StatCard title="Semestres" data="7" icon={FaBookOpen} tone="info" />
        <StatCard title="Camps" data="3" icon={FaCampground } tone="success" />
        <StatCard title="Niveles" data="9" icon={FaLayerGroup} tone="warning" />
        <StatCard title="Campuses" data="3" icon={FaMapMarkedAlt} tone="danger" />
      </SimpleGrid>

      <SimpleGrid columns={[1, 4]} gap="2">
        <Card.Root size="sm" height="auto" bg="dashboard.bg.surface">
          <Card.Header bg="green.400" rounded="sm" h="20px"/>
          <Card.Body>
            <HStack justify="space-between" pb="2">
              <Text fontSize="lg" fontWeight="bold" pb="2">4° Grado</Text>
              <Button size="sm" bg="green.400" p="0"><MdEdit /></Button>
            </HStack>
            <Text fontSize="md" fontWeight="semibold" pb="1">Jefe de Nivel</Text>
            <HStack gap="2" pl="2" bg="dashboard.bg.surfaceMuted" rounded="md" p="1" mb="2">
                <AppAvatar name="Jorge de la Garza" size={30} src="https://firebasestorage.googleapis.com/v0/b/peer-teaching.appspot.com/o/users%2Fa00838816%40tec.mx%2Fphoto?alt=media&token=bbe5cce8-62dd-49c3-9ec2-35d27ee5a613"/>
                <Text fontWeight="medium" extStyle="xs">Jorge de la Garza</Text>
            </HStack>
            <Box>
              <SimpleGrid columns="2" gap="2">
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Socios</Text>
                  <Text fontWeight="" fontSize="xl">22</Text>
                  <Progress.Root w="full" defaultValue={22} colorPalette="red" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Asistencias</Text>
                  <Text fontWeight="" fontSize="xl">12</Text>
                  <Progress.Root w="full" defaultValue={85} colorPalette="green" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Preceptorias</Text>
                  <Text fontWeight="" fontSize="xl">37</Text>
                  <Progress.Root w="full" defaultValue={45} colorPalette="blue" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Actividades</Text>
                  <Text fontWeight="" fontSize="xl">5</Text>
                  <Progress.Root w="full" defaultValue={67} colorPalette="yellow" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
              </SimpleGrid>
            </Box>
          </Card.Body>
        </Card.Root>

        <Card.Root size="sm" height="auto" bg="dashboard.bg.surface">
          <Card.Header bg="orange.400" rounded="sm" h="20px"/>
          <Card.Body>
            <HStack justify="space-between" pb="2">
              <Text fontSize="lg" fontWeight="bold" pb="2">5° Grado</Text>
              <Button size="sm" bg="orange.400" p="0"><MdEdit /></Button>
            </HStack>
            <Text fontSize="md" fontWeight="semibold" pb="1">Jefe de Nivel</Text>
            <HStack gap="2" pl="2" bg="dashboard.bg.surfaceMuted" rounded="md" p="1" mb="2">
                <AppAvatar name="Jorge de la Garza" size={30} src="https://firebasestorage.googleapis.com/v0/b/peer-teaching.appspot.com/o/users%2Fa00838816%40tec.mx%2Fphoto?alt=media&token=bbe5cce8-62dd-49c3-9ec2-35d27ee5a613"/>
                <Text fontWeight="medium" extStyle="xs">Jorge de la Garza</Text>
            </HStack>
            <Box>
              <SimpleGrid columns="2" gap="2">
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Socios</Text>
                  <Text fontWeight="" fontSize="xl">22</Text>
                  <Progress.Root w="full" defaultValue={22} colorPalette="red" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Asistencias</Text>
                  <Text fontWeight="" fontSize="xl">12</Text>
                  <Progress.Root w="full" defaultValue={85} colorPalette="green" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Preceptorias</Text>
                  <Text fontWeight="" fontSize="xl">37</Text>
                  <Progress.Root w="full" defaultValue={45} colorPalette="blue" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
                <VStack bg="dashboard.bg.surfaceMuted" rounded="md" p="2">
                  <Text fontWeight="bold">Actividades</Text>
                  <Text fontWeight="" fontSize="xl">5</Text>
                  <Progress.Root w="full" defaultValue={67} colorPalette="yellow" variant="subtle" >
                    <Progress.Track> <Progress.Range /> </Progress.Track>
                  </Progress.Root>
                </VStack>
              </SimpleGrid>
            </Box>
          </Card.Body>
        </Card.Root>

      </SimpleGrid>
    </Box>
  );
};

export default Nivel;
